import { __ } from '../../../locales'

const BackgroundFilter = ({ inputs, onInputsChange, backgroundOptions }) => {
    return (
        <div className={'input-component'}>
            <label>{__('inputs.background.label')}:</label>
            <select
                className="form-control"
                value={inputs.background}
                onInput={(ev) => onInputsChange('background', ev.target.value)}
            >
                {backgroundOptions.map((bg, index) => (<option selected={index === 0} value={bg.value}>{bg.label}</option>))}
            </select>
        </div>
    );
};

export default BackgroundFilter;
